import { Provider } from "../../Context";
import Form from "./Form";
import UserList from "./List";
import { Actions } from "./Actions";

function AppUsuario() {
  const data = Actions();
  return (
    <Provider value={data}>
      <div className="App">
        <h1>Usuários</h1>
        <div className="wrapper">
          <section className="left-side">
            <Form />
          </section>
          <section className="right-side">
            <UserList />
          </section>
        </div>
      </div>
    </Provider>
  );
}

export default AppUsuario;